export default "__VITE_ASSET__LvsZX6_s__"